import { i18n } from '@fides/fides-react-components';

import translationEN from './translations/en/main.json';
import translationDE from './translations/de/main.json';
import translationES from './translations/es/main.json';
import translationFR from './translations/fr/main.json';
import translationIT from './translations/it/main.json';
import countryEN from './translations/en/country.json';
import countryDE from './translations/de/country.json';
import countryES from './translations/es/country.json';
import countryFR from './translations/fr/country.json';
import countryIT from './translations/it/country.json';
import { JsonObject } from '../types';

const resources: JsonObject = {
  en: { ...translationEN, ...countryEN },
  de: { ...translationDE, ...countryDE },
  es: { ...translationES, ...countryES },
  fr: { ...translationFR, ...countryFR },
  it: { ...translationIT, ...countryIT },
};

i18n.setDefaultNamespace('mbs');

Object.keys(resources).forEach((lang: string) => {
  i18n.addResourceBundle(lang, 'mbs', resources[lang]);
});

export default i18n;
